import { render, staticRenderFns } from "./product.page.vue?vue&type=template&id=23aaff99&scoped=true"
import script from "./product.page.vue?vue&type=script&lang=js"
export * from "./product.page.vue?vue&type=script&lang=js"
import style0 from "./product.page.vue?vue&type=style&index=0&id=23aaff99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aaff99",
  null
  
)

export default component.exports